import { TEXT_FIELD_VALIDATOR } from '@/helpers/formHelpers/validators';
import { object } from 'yup';

export type ConfirmationWireNotesType = {
  notes?: string;
};

export const CONFIRMATION_WIRE_NOTES_INITIAL_VALUES: ConfirmationWireNotesType = {
  notes: '',
};

export const CONFIRMATION_WIRE_NOTES_VALIDATION_SCHEMA = object().shape({
  notes: TEXT_FIELD_VALIDATOR,
});
